import dynamic from 'next/dynamic'

export const DynamicMembershipSelectionModal = dynamic(
  () => import('.').then((mod) => mod.MembershipSelectionModal),
  { ssr: false },
)
